import { instance } from '../instance';
import { getApiUrl } from '@utils';

export async function cookieCheck() {
  const requestConfig = {
    method: 'get',
    url: `${getApiUrl()}/auth`,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  const res = await instance(requestConfig);
  return res;
}
